module.exports = __webpack_public_path__ + "static/media/img_buble_02.5541f13c.png";